<div *ngIf="multiple">
  <div *ngIf="projectStatus.success > 0 && projectStatus.processing === 0 && projectStatus.failed === 0">
    <div class="finished">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success === 0 && projectStatus.processing > 0 && projectStatus.failed === 0">
    <div class="inProgress">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success === 0 && projectStatus.processing === 0 && projectStatus.failed > 0">
    <div class="failed">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success === 0 && projectStatus.processing === 0 && projectStatus.failed === 0">
    <div class="empty">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success > 0 && projectStatus.processing > 0 && projectStatus.failed === 0">
    <!-- <div class="finished">
      <mat-progress-bar
        style="bottom: 0px; width: 50%; border-radius: 0px 0px 0px 10px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div> -->

    <div class="inProgress">
      <mat-progress-bar
        style="bottom: 0px; width: 100%; left: 0%; border-radius: 0px 0px 10px 0px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success === 0 && projectStatus.processing > 0 && projectStatus.failed > 0">
    <div class="inProgress">
      <mat-progress-bar
        style="bottom: 0px; width: 50%; border-radius: 0px 0px 0px 10px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>
    <div class="failed">
      <mat-progress-bar
        style="bottom: 0px; width: 50%; left: 50%; border-radius: 0px 0px 10px 0px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success > 0 && projectStatus.processing === 0 && projectStatus.failed > 0">
    <!-- <div class="finished">
      <mat-progress-bar
        style="bottom: 0px; width: 50%; border-radius: 0px 0px 0px 10px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div> -->
    <div class="failed">
      <mat-progress-bar
        style="bottom: 0px; width: 100%; left: 0%; border-radius: 0px 0px 10px 0px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>

  <div *ngIf="projectStatus.success > 0 && projectStatus.processing > 0 && projectStatus.failed > 0">
    <div class="finished">
      <mat-progress-bar
        style="bottom: 0px; width: 34%; border-radius: 0px 0px 0px 10px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>

    <div class="inProgress">
      <mat-progress-bar
        style="bottom: 0px; width: 34%; left: 32%; border-radius: 0px 0px 0px 0px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>

    <div class="failed">
      <mat-progress-bar
        style="bottom: 0px; width: 34%; left: 66%; border-radius: 0px 0px 10px 0px"
        class="bar-multiple"
        [value]="'100'"></mat-progress-bar>
    </div>
  </div>
</div>

<div *ngIf="!multiple">
  <div *ngIf="top; else bottom">
    <div *ngIf="progress === 100" class="finished">
      <mat-progress-bar class="bar-thin" [value]="progress"></mat-progress-bar>
    </div>

    <div *ngIf="progress >= 1 && progress <= 99" class="inProgress">
      <mat-progress-bar class="bar-thin" [value]="progress"></mat-progress-bar>
    </div>

    <div *ngIf="progress === 0" class="notStarted">
      <mat-progress-bar class="bar-thin" [value]="100"></mat-progress-bar>
    </div>
  </div>

  <ng-template #bottom>
    <div *ngIf="versionStatus.overall === 'success'" class="finished">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="progress"></mat-progress-bar>
    </div>

    <div *ngIf="versionStatus.overall === 'processing' && progress >= 1" class="inProgress">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="progress"></mat-progress-bar>
    </div>

    <div
      *ngIf="
        (versionStatus.overall === 'processing' && progress === 0) ||
        (versionStatus.overall === 'waiting' && progress === 0)
      "
      class="notStarted">
      <mat-progress-bar style="bottom: 0px" class="bar" [value]="'100'"></mat-progress-bar>
    </div>

    <div *ngIf="versionStatus.overall === 'failed'" class="failed">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="'100'"></mat-progress-bar>
    </div>

    <div *ngIf="versionStatus.overall === 'waiting'" class="waiting">
      <mat-progress-bar
        style="bottom: 0px"
        class="bar"
        [value]="'100'"></mat-progress-bar>
    </div>
  </ng-template>
</div>

<div *ngIf="mode" class="loading">
  <mat-progress-bar class="bar-thin" [value]="progress" [mode]="mode"></mat-progress-bar>
</div>
